import { LazyLanguageSelector } from "@faire/help-center-self-serve/components/LanguageSelector/LazyLanguageSelector";
import { isMobileApp } from "@faire/help-center-utils/lib/isMobileApp";
import { availableLanguageSelectorLocales } from "@faire/help-center-utils/serialized-data/availableLanguageSelectorLocales";
import {
  browserLevelLanguage,
  browserLevelLocaleKey,
} from "@faire/help-center-utils/serialized-data/getLocale";
import { getUserToken } from "@faire/help-center-utils/serialized-data/getUser";
import { getSettingHelpCenterEnableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterEnableLocales";
import { FaireLogo } from "@faire/web--source/slate/icons/FaireLogo";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { trackCxFoundationsBackToHelpCenterClick } from "@faire/web-api--source/events/cxFoundations/click/backToHelpCenter";
import { trackCxFoundationsBackToHelpCenterWithBrandOrderClick } from "@faire/web-api--source/events/cxFoundations/click/backToHelpCenterWithBrandOrder";
import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import home from "@faire/web-api--source/routes/support";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

import { clearLocalStorage } from "../../utils/localStorage";

interface IProps {
  issueType: string;
  selectedBrandOrder?: ISelfServeBrandOrder;
}

export const SelfServeHeader: React.FC<IProps> = ({
  issueType,
  selectedBrandOrder,
}) => {
  const { pathname } = useLocation();
  const userToken = getUserToken() ?? "";

  const trackEvents = () => {
    trackCxFoundationsBackToHelpCenterClick(userToken, issueType, pathname);
    trackCxFoundationsBackToHelpCenterWithBrandOrderClick(
      userToken,
      selectedBrandOrder?.brand_order?.token ?? ""
    );
  };

  const clearStorageAndTrackEvent = () => {
    clearLocalStorage();
    trackEvents();
  };

  const renderLanguageSelector = () => {
    if (!getSettingHelpCenterEnableLocales()) {
      return null;
    }

    if (isMobileApp()) {
      return null;
    }

    return (
      <LanguageSelectorWrapper>
        <LazyLanguageSelector
          eventKey="help-center-self-serve-top"
          position="downLeft"
          browserLanguage={browserLevelLanguage() as Language}
          browserLocale={browserLevelLocaleKey()}
          availableLocales={availableLanguageSelectorLocales}
          assignLocalizedUrl
        />
      </LanguageSelectorWrapper>
    );
  };

  return (
    <SelfServeHeaderWrapper>
      <FaireLogoWrapper>
        <Link to={home()} onClick={clearStorageAndTrackEvent}>
          <FaireLogo />
        </Link>
      </FaireLogoWrapper>
      {renderLanguageSelector()}
    </SelfServeHeaderWrapper>
  );
};

const SelfServeHeaderWrapper = styled(Row).attrs({
  justify: "flex-start",
  align: "center",
})`
  height: 60px;
  padding: 32px;
  position: relative;
`;

const FaireLogoWrapper = styled.div`
  position: absolute;
  margin: 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const LanguageSelectorWrapper = styled.div`
  position: absolute;
  right: ${getSpacing("3x")};
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;
